import React from 'react';
import { Toast, ToastPlacement as TOAST_PLACEMENT, ToastSkin as TOAST_SKIN, } from 'wix-ui-tpa/cssVars';
import { TOAST } from '../../../common/constants/data-hooks';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../context/api-context/use-api';
import { classes } from './toast-root.st.css';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getToastEffect } from '../../../common/store/comments/comments-selectors';
import { unreachable } from '../../../ts-utils';
export const ToastRoot = React.memo(() => {
    const { resourceId } = useConfiguration();
    const { isMobile, toastEffect } = useApi((state) => ({
        isMobile: getIsMobile(state),
        toastEffect: getToastEffect(state, resourceId),
    }));
    const t = useTranslate();
    const [hiddenToastTimestamp, setHiddenToastTimestamp] = React.useState(undefined);
    const hideToast = () => {
        setHiddenToastTimestamp(toastEffect?.timestamp);
    };
    React.useEffect(() => {
        if (toastEffect) {
            const timeoutId = setTimeout(hideToast, 5000);
            return () => clearTimeout(timeoutId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toastEffect?.timestamp]);
    if (!toastEffect || hiddenToastTimestamp === toastEffect?.timestamp) {
        return null;
    }
    const { message, skin, isHidden } = toastEffect;
    const toast = (React.createElement(Toast, { "data-hook": TOAST, skin: TOAST_SKIN[skin], onClose: hideToast, className: classes.toast, placement: isMobile && !isHidden ? TOAST_PLACEMENT.bottomFullWidth : TOAST_PLACEMENT.inline, shouldShowCloseButton: true }, (() => {
        switch (message.type) {
            case 'TRANSLATION':
                return t(message.key, message.keyValue);
            case 'EXTERNAL_TRANSLATION':
                return t(message.key, message.keyValue);
            case 'CUSTOM':
                return message.content;
            default:
                throw unreachable(message);
        }
    })()));
    if (toastEffect.isHidden) {
        return React.createElement("div", { className: classes.hiddenContainer }, toast);
    }
    return isMobile ? toast : React.createElement("div", { className: classes.container }, toast);
});
export default ToastRoot;
//# sourceMappingURL=toast-root.js.map